import { render } from "./IconSearch.vue?vue&type=template&id=5894a77a"
const script = {}
script.render = render

export default script